module.exports = __webpack_public_path__ + "img/Image1.dea9cec4.png";